import axios from 'axios';
import { getCookie } from '../functions/general/cookies';

export const cancelTokenSource = axios.CancelToken.source();

const BASE_URL = process.env.REACT_APP_SERVER_LINK || 'https://api.fitdoc.be/webservicefitdoc/v1/';

// Create an Axios instance
let api = axios.create({
    baseURL: BASE_URL,
    cancelToken: cancelTokenSource.token
})

// Add an interceptor to include the bearer token in requests
api.interceptors.request.use(
    (config) => {
        const token = getCookie('fit-token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 Unauthorized responses
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (axios.isCancel(error)) {
            // This handles the case when the request was canceled
            console.log('Request canceled', error.message);
            return null;
        }
        if (error.response && error.response.status === 401) {
            window.location.href = '/login'; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export default api;
